import { memo } from 'react';

import AIModelReadyIconSVG from '@/assets/ai-model-ready-filled.svg?react';
import { Icon, IconProps } from '@/components/core';

const IAIModelReadyIcon = ({ ...rest }: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={AIModelReadyIconSVG} {...rest} />
);

export const AIModelReadyIcon = memo(IAIModelReadyIcon) as typeof IAIModelReadyIcon;
